// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ay","message":"az","buttons":"aA","buttonWrapper":"aB","btn":"aC"};